export default "__VITE_ASSET__D5fAtk$9__"